import React from "react"
import { Link } from "react-router-dom"
import "./index.scss"
import Button from "components/common/Button"

const HeroHeader = ({
  title,
  searchEnabled,
  buttonEnabled,
  buttonLabel,
  description,
  searchParam,
  onChange,
  routeList,
  activeColor,
  activeItem,
  onButtonClick,
  onClickSearch,
  onSearchBlur,
}) => {
  return (
    <div className="hero-header">
      <div className="hero-wrapper">
        <nav className="app-breadcrumb">
          <ul>
            {Object.keys(routeList).map((item, i) => (
              <li
                key={i}
                className={activeItem === routeList[item] ? "is-active" : ""}
                style={{
                  color: activeColor,
                }}
              >
                <Link to={item}>{routeList[item]}</Link>
              </li>
            ))}
          </ul>
        </nav>
        <h1 className="title">{title}</h1>
        {description ? <p className="description">{description}</p> : null}
        {searchEnabled ? (
          <div className="input-field">
            <input
              type="text"
              name="searchParam"
              value={searchParam}
              placeholder="Search"
              autoFocus
              onChange={onChange}
              onKeyDown={onChange}
              onBlur={onSearchBlur}
            />
          </div>
        ) : buttonEnabled ? (
          <div className="button-wrapper">
            <Button size="small" label={buttonLabel} onClick={onButtonClick} />
            <Button
              size="small"
              customClassName="ml-s"
              label={<span className="icon-search" />}
              onClick={onClickSearch}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default HeroHeader
